/**
 * KEY==Value for equality checks
 */
export enum ImplementAccountingValueModeEnum {
  DIRECT = 'DIR',
  POSITIVE_DIFFERENCE_BETWEEN_NEIGHBOURS = 'POSDIF',
  NEGATIVE_DIFFERENCE_BETWEEN_NEIGHBOURS = 'NEGDIF',
  ABSOLUTE_DIFFERENCE_BETWEEN_NEIGHBOURS = 'ABSDIF',
  TIME_IN_ACTIVE_STATE = 'TIMACT',
}
